/**
 * Armazenamento da conversa do widget de ajuda.
 *
 * Fica em módulo próprio, sem importar axios nem o store, para que o AuthActions possa
 * limpar a conversa no logout sem criar ciclo de import (AxiosInstance já importa o store,
 * que importa o AuthActions).
 *
 * A conversa vive só na aba: nada é gravado no servidor.
 */

const STORAGE_KEY = 'ai_support_conversation';

// Turnos mantidos no navegador. O backend também limita o que considera.
const MAX_STORED_MESSAGES = 20;

/** Lê a conversa da sessão, tolerando conteúdo inválido de uma versão anterior. */
export function loadAiSupportConversation() {
    try {
        const raw = sessionStorage.getItem(STORAGE_KEY);
        const parsed = raw ? JSON.parse(raw) : [];
        return Array.isArray(parsed) ? parsed : [];
    } catch {
        return [];
    }
}

/** Guarda a conversa da sessão, ignorando falha de cota ou modo restrito. */
export function saveAiSupportConversation(messages) {
    try {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(messages.slice(-MAX_STORED_MESSAGES)));
    } catch {
        // Sem persistência a conversa continua na memória; não vale interromper o usuário.
    }
}

/**
 * Apaga a conversa.
 *
 * Chamado no logout: sessionStorage pertence à aba e não à sessão de login, então sem isso
 * a conversa de quem saiu ficaria visível para quem entrasse em seguida no mesmo navegador.
 * Em recepção de barbearia o computador costuma ser compartilhado, e o usuário pode ter
 * digitado nome ou telefone de cliente na pergunta.
 */
export function clearAiSupportConversation() {
    try {
        sessionStorage.removeItem(STORAGE_KEY);
    } catch {
        // Navegador em modo restrito: não havia o que limpar.
    }
}
